import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import AOS from "aos";

import logoImg from "../../assets/images/logo_eolica.png";
import icon1 from "../../assets/images/footer/FOOTER Icon 1.png";
import icon2 from "../../assets/images/footer/FOOTER Icon 2.png";
import icon3 from "../../assets/images/footer/FOOTER Icon 3.png";
import icon4 from "../../assets/images/footer/FOOTER Icon 4.png";

import "aos/dist/aos.css";
import "./styles.css";

const Footer = function () {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="footer">
      <Row>
        <Col xs={12} md={12} sm={12} lg={6}>
          <div className="footer-info contact-us">
            <div>
              <div className="footer-info-header">
                Contact Us &nbsp;&nbsp;|&nbsp;&nbsp;
                <Link to="/careers" className="work-with-us">
                  {" "}
                  Careers
                </Link>
              </div>
              <div className="footer-info-line">
                <div className="icon-container">
                  <img src={icon1} className="icon-footer-1" alt="home" />
                </div>
                <p> Rua do Bom Jesus, n° 207 | Recife-PE Brazil </p>
              </div>
              <div className="footer-info-line">
                <div className="icon-container">
                  <img src={icon2} className="icon-footer-2" alt="tel" />
                </div>
                <p> Tel: +55 81 2128-8181 </p>
              </div>
              <div className="footer-info-line">
                <div className="icon-container">
                  <img src={icon3} className="icon-footer-3" alt="email" />
                </div>
                <p> Email: eolica@eolica.com.br </p>
              </div>
              <div className="footer-info-line insta">
                <div className="icon-container">
                  <img src={icon4} className="icon-footer-4" alt="instagram" />
                </div>
                <p>
                  {" "}
                  <a
                    href="https://www.instagram.com/eolicatec/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @eolicatec{" "}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </Col>
        <Col xs={12} md={12} sm={12} lg={6}>
          <div className="footer-info footer-logo">
            <div className="footer-info-line">
              <img src={logoImg} alt="Eólica" />
            </div>
            <div className="footer-info-line">
              <small>© Eólica Tecnologia All Rights Reserved </small>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
